module.exports = __webpack_public_path__ + "assets/img/19-l.e60bea3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/19-l.jpg
// module id = H4T9
// module chunks = 0